var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatusWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 2.66699C23.3638 2.66699 29.333 8.6362 29.333 16C29.333 23.3638 23.3638 29.333 16 29.333C8.6362 29.333 2.66699 23.3638 2.66699 16C2.66699 8.6362 8.6362 2.66699 16 2.66699Z",
    fill: "#F2BE04"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.374 20.6963C17.2943 20.6965 18.04 21.4429 18.04 22.3633C18.04 23.2836 17.2943 24.0301 16.374 24.0303C15.4535 24.0303 14.707 23.2838 14.707 22.3633C14.707 21.4428 15.4535 20.6963 16.374 20.6963ZM16.333 7.96973C17.2535 7.96973 18 8.71624 18 9.63672V17.3994C17.9998 18.3197 17.2533 19.0654 16.333 19.0654C15.4128 19.0653 14.6672 18.3196 14.667 17.3994V9.63672C14.667 8.71635 15.4127 7.9699 16.333 7.96973Z",
    fill: "#6B4E11"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusWarning);
export default __webpack_public_path__ + "static/media/status-warning.b8cd1b96f7a6671bfc30c2b51ae8eed1.svg";
export { ForwardRef as ReactComponent };